
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Events </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm register-summer-camp section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Registration <span>Form</span></h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">

                <div class="reg-form-sum mt-3">

                    <form action="#" class="row gx-3 comments-form contact-form">
                        <div class="col-md-12 col-sm-12">
                            <div class="styled-input wide">
                                <input type="text" required />
                                <label>Name <span class="star">*</span></label>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="styled-input wide">
                                <input type="text" required />
                                <label>Mobile Number<span class="star">*</span></label>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="styled-input wide">
                                <input type="text" required />
                                <label>E-mail <span class="star">*</span></label>
                            </div>
                        </div>


                    </form>
                </div>

                <div class="col-xs-12 mt-3 text-center">
                    <a href="" class="btn button--effect-1 w-50"><span>
                            SUBMIT</span> <span class="icon-right-arrow"></span>
                    </a>
                </div>

            </div>
            <div class="col-md-6">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/konkan-kanya-band.webp"
                        alt="GHRSCF" class="w-100">
                </div>

            </div>
        </div>
    </div>
</section>
